import React, { useState } from 'react';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { ModalProvider } from './contexts/ModalContext';
import LoginScreen from './components/auth/LoginScreen';
import App from './App';
import { Loader2 } from 'lucide-react';

// Componente que gerencia a navegação de autenticação
const AuthNavigator = () => {
    const { user, loading, error, login, register, loginWithGoogle, resetPassword, logout } = useAuth();

    // Loading state com app blur atrás
    if (loading) {
        return (
            <div className="relative min-h-screen">
                {/* App preview borrado no fundo */}
                <div className="absolute inset-0 filter blur-sm opacity-40 pointer-events-none overflow-hidden">
                    <App firebaseUser={null} />
                </div>
                {/* Loader overlay */}
                <div className="absolute inset-0 bg-black/50 flex items-center justify-center z-50">
                    <div className="text-center bg-white dark:bg-gray-900 p-8 rounded-3xl shadow-2xl">
                        <Loader2 size={48} className="text-indigo-600 animate-spin mx-auto mb-4" />
                        <p className="text-gray-700 dark:text-gray-300 font-medium">Carregando...</p>
                    </div>
                </div>
            </div>
        );
    }

    // Se usuário estiver autenticado, mostra o app
    if (user) {
        return <App firebaseUser={user} onLogout={logout} onResetPassword={resetPassword} />;
    }


    // Tela de login/registro com app blur atrás
    const AuthOverlay = ({ children }) => (
        <div className="relative min-h-screen bg-gray-900">
            {/* App preview borrado no fundo */}
            <div className="absolute inset-0 filter blur-sm opacity-30 pointer-events-none overflow-hidden">
                <App firebaseUser={null} />
            </div>
            {/* Overlay escuro (Fosco) */}
            <div className="absolute inset-0 bg-black/60 z-10" />
            {/* Conteúdo de login */}
            <div className="relative z-20 w-full h-full">
                {children}
            </div>
        </div>
    );

    // Sempre mostra a tela de login exclusivamente com Google
    return (
        <AuthOverlay>
            <LoginScreen
                onGoogleLogin={loginWithGoogle}
                error={error}
                loading={loading}
            />
        </AuthOverlay>
    );
};

// Componente principal que envolve tudo com AuthProvider
const AppWrapper = () => {
    return (
        <AuthProvider>
            <ModalProvider>
                <AuthNavigator />
            </ModalProvider>
        </AuthProvider>
    );
};

export default AppWrapper;
